import React from 'react';

import { Link } from 'react-router-dom';

import { LoginLoc } from '../loc/login';
import { loc } from '../lib/loc';

export default function Success({ message, title }) {
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        paddingBottom: '160px',
      }}
    >
      <div style={{ maxWidth: '480px', margin: 'auto', textAlign: 'center' }}>
        <img src={`${process.env.REACT_APP_PATH}public/img/ok-icon.svg`} style={{ padding: '50px' }} alt={''} />
        <h3>{title}</h3>
        <p style={{ marginBottom: '15px' }}>{message}</p>
        <Link to="/login/" style={{ border: 'none' }}>
          <button className="login-form__login-btn">{loc(LoginLoc.signIn)}</button>
        </Link>
      </div>
    </div>
  );
}
